import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
export const NoRowsOverlay = ({ action, message, title = 'No API keys' })=>/*#__PURE__*/ _jsx("div", {
        className: "flex items-center justify-center h-full p-8",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ _jsx("svg", {
                    className: "mx-auto h-12 w-12 text-gray-400",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ _jsx("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M15 7a2 2 0 012 2m0 0a2 2 0 012 2m-2-2h-6m6 0v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6a2 2 0 012-2m0 0V7a2 2 0 012-2m-2 2h6m-6 0a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2h-6z"
                    })
                }),
                /*#__PURE__*/ _jsx("h3", {
                    className: "mt-2 text-sm font-medium text-gray-900",
                    children: title
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "mt-1 text-sm text-gray-500",
                    children: message
                }),
                action && /*#__PURE__*/ _jsx("div", {
                    className: "mt-5 flex justify-center",
                    children: action
                })
            ]
        })
    });
